if (typeof URL.parse !== 'function') {
  URL.parse = function (url: string, base?: string): URL | null {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}
